import React from 'react';
import { Row, Col, List } from 'reactstrap';
import PropTypes from 'prop-types';

import Body from '../Components/layout/Body';
import ReviewRow from '../Components/layout/ReviewRow';
import UpdateButton from '../Components/navigation/UpdateButton';
import { ENVIRONMENT_BUTTONS } from './ConstEnvironmentBtns';
import { POSITION_BUTTONS } from './ConstBodyPositionBtns';
import { SUBTABS, CONTEXTS_STEPS } from './ConstPaths';
import './Views.scss';
import { IMPORTANCE_BUTTONS } from './ConstImportanceBtns';

//the props should have been picked before getting to review,
//so make them all required (except name, which is always optional)
const propTypes = {
  firstName: PropTypes.string,
  environments: PropTypes.arrayOf(PropTypes.string).isRequired,
  bodyPositions: PropTypes.arrayOf(PropTypes.string).isRequired,
  indepSetup: PropTypes.string.isRequired,
  indepUse: PropTypes.string.isRequired,
  onContinue: PropTypes.func.isRequired
};

const defaultProps = {
  firstName: 'the client',
};

//content sub-component with unique content for this page
function ContextsReviewContent(props) {

  const environments = props.environments;
  const bodyPositions = props.bodyPositions;
  const indepSetup = props.indepSetup;
  const indepUse = props.indepUse;

  console.log("rendering GatherInfoContextReview");

  const BASE_URL = SUBTABS.CONTEXTS + "/";
  const steps = CONTEXTS_STEPS;

  return(
  <Row>
    <Col>
      <ReviewRow 
        heading="Environments" 
        nextRoute={BASE_URL+steps.ENVIRONMENTS}
        values={environments}
        lookup={ENVIRONMENT_BUTTONS}
      />
      <ReviewRow 
        heading="Positions" 
        nextRoute={BASE_URL+steps.POSITIONS}
        values={bodyPositions}
        lookup={POSITION_BUTTONS}
      />
      <ReviewRowIndependence 
        heading="Independence" 
        nextRoute={BASE_URL+steps.INDEPENDENCE}
        indepSetup={indepSetup}
        indepUse={indepUse}
        lookup={IMPORTANCE_BUTTONS}
      />
    </Col>
    <Col lg={2}></Col>
  </Row>
  );
}

//a special version of the Review Row to handle the 2 independence values
function ReviewRowIndependence(props){
  const heading = props.heading;
  const nextRoute = props.nextRoute;
  const indepSetup = props.indepSetup;
  const indepUse = props.indepUse;
  const lookup = props.lookup;

  var indepSetupLabel;
  if(indepSetup){
    indepSetupLabel = 
    ((lookup.find(o => o.value === indepSetup)).label) + " for setup";
  }
  else{
    indepSetupLabel = "None entered for setup";
  }

  var indepUseLabel;
  if(indepUse){
    indepUseLabel = 
    ((lookup.find(o => o.value === indepUse)).label) + " for usage";
  }
  else{
    indepUseLabel = "None entered for usage";
  }

  return(
    <Row className="aa-review-row border-top">
      <Col>
        <Row>
          <Col>
            <strong>{heading}</strong>
          </Col>
          <Col>
            <UpdateButton nextRoute={nextRoute} />
          </Col>
        </Row>
        <Row>
          <Col>
            <List type="unstyled" className="aa-values-list">
              <li key="setup">{indepSetupLabel}</li>
              <li key="use">{indepUseLabel}</li>
            </List> 
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component.
//since the main goal step includes a form, receive the initial form values via props,
//along with setters to change those values based on the form input.
function GatherInfoContextsReview(props) {
  const firstName = props.firstName;
  const environments = props.environments;
  const bodyPositions = props.bodyPositions;
  const indepSetup = props.indepSetup;
  const indepUse = props.indepUse;
  const onContinue = props.onContinue;

  const pageData = {
    image: "./assets/images/target-icon.jpg", //not yet used
    faIcon: "fa-users",
    pageSymbolClassName: "aa-section-symbol gather",

    title: `Review ${firstName}'s Contexts of AT Use`,
    subTitle: "Great news! We've visited all 3 sections on contexts. Here's what we've got:",
    learnMore: {linkText: "",
                title: "",
                content: ""
                },
    nextRoute: "", //not used since we have an onContinue callback
    sidebar: false
  }

  return(
    <>
    <Body page={pageData} 
      contentComponent={
        <ContextsReviewContent 
          environments={environments} 
          bodyPositions={bodyPositions} 
          indepSetup={indepSetup} 
          indepUse={indepUse}
        />
      }
      onContinue={onContinue} 
    />
    </>
  );
}

GatherInfoContextsReview.propTypes = propTypes;
GatherInfoContextsReview.defaultProps = defaultProps;

export default GatherInfoContextsReview;